// extracted by mini-css-extract-plugin
export var statItem = "_kn-1";
export var statsRow = "_kn-0";